import { render, staticRenderFns } from "./Empatia.vue?vue&type=template&id=6fbdbbb9&scoped=true"
import script from "./Empatia.vue?vue&type=script&lang=js"
export * from "./Empatia.vue?vue&type=script&lang=js"
import style0 from "./Empatia.vue?vue&type=style&index=0&id=6fbdbbb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbdbbb9",
  null
  
)

export default component.exports